var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacilityManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tabler:building"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.625 18.375H18.375M7.875 7H8.75M7.875 10.5H8.75M7.875 14H8.75M12.25 7H13.125M12.25 10.5H13.125M12.25 14H13.125M4.375 18.375V4.375C4.375 3.91087 4.55937 3.46575 4.88756 3.13756C5.21575 2.80937 5.66087 2.625 6.125 2.625H14.875C15.3391 2.625 15.7842 2.80937 16.1124 3.13756C16.4406 3.46575 16.625 3.91087 16.625 4.375V18.375",
    stroke: "#ACBED2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacilityManagement);
export default __webpack_public_path__ + "static/media/FacilityManagement.734ace159c9c423b1fd9a4ea2c4a2569.svg";
export { ForwardRef as ReactComponent };